import {createApp} from "vue";
import store from './store.js'
import Error from './modules/errors';

/* For {{ total.tax.tax | currency }} */
// import router from "../../nova/resources/js/router";
import router from "./routes/my-billing";
import Stripe from "./modules/stripe";
import PmApp from "./pages/PmApp.vue";
import Bugsnag from "@bugsnag/js";
import {vfmPlugin} from 'vue-final-modal'


require('./bootstrap');


const bugsnagVue = Bugsnag.getPlugin('vue');
const app = createApp(PmApp).use(store);
app.use(router);
app.use(bugsnagVue);
app.use(vfmPlugin);

app.mount('#app')

app.config.globalProperties.$stripe = Stripe;
app.config.globalProperties.$error = Error;
